<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">
            {{ getLearnerCourse.title }}
          </div>
        </div>
        <div>
          <img :src="require('../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2 main-tenant-color">Modules</page-header>
        <p>0 out of 3 completed</p>
      </div>
      <div class="">
        <div v-for="(module, i) in getLearnerModules" :key="i" class="w-full">
          <module-card :module="module" class="my-4 mx-2" />
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ModuleCard: () => import("@/components/learner/module-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchLearnerModules", "fetchSingleLearnerCourse"]),
  },
  computed: {
    ...mapGetters(["getLearnerModules", "getLearnerCourse"]),
  },
  mounted() {
    this.fetchSingleLearnerCourse({
      id: this.$route.params.id,
    });
    this.fetchLearnerModules({ id: this.$route.params.id });
  },
};
</script>
<style scoped></style>
